export default "__VITE_ASSET__C6tl3cL7__"